export default __webpack_public_path__ + "static/property-img-1_1400-d5c9da0c2ba9a5b2a0721f3f5a85e5b2.jpg";